import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

export class Membership extends TrelloModel {}
